var jcsfApp;
(function (jcsfApp) {
	var app;
	(function (app) {
		var userList;
		(function (userList) {
			var UsersController = (function () {
				function UsersController(
					$window,
					constantService,
					dataService,
					authService
				) {
					var vm = this;
					vm.orderBy = sessionStorage.getItem('usersOrderBy') || 'UserName';
					vm.orderByReverse = false;
					vm.$window = $window;
					vm.authService = authService;
					vm.userFilter = '';
					vm.showLogView = false;
					vm.currentLogGrid = '';

					vm.activityStatusFilter = '';
					vm.activityUsernameFilter = '';

					authService.fillAuthData();

					if (
						authService.authentication.userName == null ||
						!authService.authentication.isAuth ||
						!authService.authentication.userInfo.Roles.includes('Administrator')
					) {
						$scope.$state.go('home');
					}

					vm.constantService = constantService;
					vm.dataService = dataService;
					vm.getUsers();
				}

				UsersController.prototype.setOrderBy =
					/**
					 *
					 * @param {string} column
					 */
					function setOrderBy(column) {
						this.orderByReverse =
							this.orderBy === column ? !this.orderByReverse : false;
						this.orderBy = column;
						sessionStorage.setItem('usersOrderBy', column);
					};

				UsersController.prototype.printReport = function () {
					this.$window.open(
						'/reporting/memberlist/',
						'_blank',
						'location=no,height=1000,width=1000,scrollbars=yes,status=no'
					);
					return false;
				};
				UsersController.prototype.remove = function (Id) {
					var $this = this;
					if (
						this.$window.confirm(
							'Please confirm you want to delete this Member?'
						)
					) {
						this.dataService
							.remove(this.constantService.apiProfileURI + Id)
							.then(function () {
								$this.getUsers();
							});
					}
				};

				UsersController.prototype.reactivate = function (Id, isActive) {
					var $this = this;
					if (isActive === 'Yes') {
						alert('This memeber is already active');
					} else if (
						this.$window.confirm(
							'Please confirm you want to reactivate this Member?'
						)
					) {
						this.dataService
							.remove(this.constantService.apiProfileURI + 'reactivate/' + Id)
							.then(function () {
								$this.getUsers();
							});
					}
				};

				UsersController.prototype.getUsers = function (DeletedOnly) {
					var $this = this;
					this.dataService
						.get(this.constantService.apiProfileURI)
						.then(function (result) {
							$this.users = result;
						});
				};

				UsersController.prototype.getAudits = function (DeletedOnly) {
					var $this = this;
					this.dataService
						.get(
							this.constantService.apiProfileURI + 'getAudits/' + 5 + "/'test'"
						)
						.then(function (result) {
							$this.audits = result;
							$this.currentLogGridRecords = result;
							$this.currentLogGridRecordHeaders = Object.keys(
								result.at(0) || {}
							);
						});

					this.showLogView = true;
					this.currentLogGrid = 'Audits';
				};

				UsersController.prototype.getActivity = function (statusX, usernameX) {
					var $this = this;

					this.showLogView = true;
					this.currentLogGrid = 'User Activity';

					this.dataService
						.get(
							this.constantService.apiProfileURI +
								"getActivity/'" +
								this.activityStatusFilter +
								"'/'" +
								this.activityUsernameFilter +
								"'"
						)
						.then(function (result) {
							$this.userActivity = result;
							$this.currentLogGridRecords = result;
							$this.currentLogGridRecordHeaders = Object.keys(
								result.at(0) || {}
							);
						});
				};

				UsersController.prototype.getRecordViews = function () {
					var $this = this;

					this.showLogView = true;
					this.currentLogGrid = 'Student Profile';

					this.dataService
						.get(this.constantService.apiProfileURI + 'getRecordViews')
						.then(function (result) {
							$this.userRecordViews = result;
							$this.currentLogGridRecords = result;
							$this.currentLogGridRecordHeaders = Object.keys(
								result.at(0) || {}
							);
						});
				};

				UsersController.$inject = [
					'$window',
					'constantService',
					'dataService',
					'authService',
				];
				return UsersController;
			})();
			angular.module('jcsfApp').controller('UsersController', UsersController);
		})((userList = app.userList || (app.userList = {})));
	})((app = jcsfApp.app || (jcsfApp.app = {})));
})(jcsfApp || (jcsfApp = {}));
